import React from 'react'
import Base from './Base'
import Success from '../../Images/success.gif'
import Error from '../../Images/error.gif'
import Warning from '../../Images/warning.gif'
import StepsUserFormBase from './StepsUserFormBase'
import { allState as mapStateToProps, allDispatch as mapDispatchToProps } from "../../Redux/Selectors"
import { Form, Card , Button, Row, Col, } from "antd"
import { withBreakpoints } from "react-breakpoints"
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

class PostCheckoutSuccess extends React.Component{

    constructor(props) {
        super(props);
    }

    componentDidMount(){

        window.setTimeout( () => {
             this.props.history.push("/")}
             ,7000);
    }

    render(){
        if (this.props.history.location.state.isStepUser){
            return(
                <StepsUserFormBase>
                    <center>
                        <h1> Te informamos que tu pago ha sido realizado con éxito</h1>
                        <h1> Recibirás un email cuando procesemos tu pago. En breve te redireccionaremos para continuar con tu proceso</h1>
                        <img alt="success" src={Success} className="succes-checkout" style={{ height: "300px", marginTop: "15px", marginBottom: "15px" }} />    
                    </center>
                    <center>
                        <Button 
                            style={{
                            color: '#FFFFFF' ,
                            background: '#353FDF',
                            border: '1px solid #353FDF',
                            borderRadius: '5px' 
                            }}
                            onClick={() => this.props.history.push("/")}> Continuar 
                        </Button>
                    </center>

                </StepsUserFormBase>
            )
        }else{
            return (
                <Base
                    selected = "checkout-success">
                        <Card>
                            <Row>
                                <Col align='center'>
                                    <h1> Te informamos que tu pago ha sido realizado con éxito</h1>
                                    <h1> En breve te redireccionaremos a tu pantalla principal</h1>
                                    <img alt="success" src={Success} className="succes-checkout" style={{ height: "300px", marginTop: "15px", marginBottom: "15px" }} />
                                </Col>
                            </Row>
                        </Card>
                        <center>
                            <Button 
                                style={{
                                color: '#FFFFFF' ,
                                background: '#353FDF',
                                border: '1px solid #353FDF',
                                borderRadius: '5px' 
                                }}
                                onClick={() => this.props.history.push("/")}> Continuar 
                            </Button>
                        </center>
                </Base>
            )          
        }
    }
}

const Checkout = Form.create({ nombre: 'checkout-success' })(withBreakpoints(PostCheckoutSuccess));
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Checkout));